<template>
  <div class="top-content flex-column" :class="queryName" v-if="info.show_menu">
    <div class="flex-row tt-top" :style="{height: info.height,background: info.backgroundColor}">
      <img v-if="info.background" class="top-background" :class="info.height=='auto'&& !list.length?'relative':''"
        :src="info.background" alt="">
      <div class="w1250 img-box">
        <template v-for="item in list">
          <img v-if="item.image" class="img-item" :src="item.image" alt="" :style="item.style">
        </template>
        <template v-if="website_id == '32' && pc">
          <div class="login_module_box">
            <div class="login_l_z">
              <span v-text="islogin=='1'?userName:'登录/注册'"></span>
              <div class="login-menu" :style="{background: info.backgroundColor}" v-if="islogin==0">
                <div @click="goLogin(1)" :style="{'--childBgColor':info.childHoverStyle.backgroundColor,'--childColor':info.childHoverStyle.color}">登录</div>
                <div @click="goLoginRegister(1)" :style="{'--childBgColor':info.childHoverStyle.backgroundColor,'--childColor':info.childHoverStyle.color}">注册</div>
              </div>
              <div class="login-menu" :style="{background: info.backgroundColor}" v-if="islogin==1">
                <div @click="goPersonCenter" :style="{'--childBgColor':info.childHoverStyle.backgroundColor,'--childColor':info.childHoverStyle.color}">个人中心</div>
                <div @click="quitLogin" :style="{'--childBgColor':info.childHoverStyle.backgroundColor,'--childColor':info.childHoverStyle.color}">退出登录</div>
              </div>
            </div>
            <div class="user_icon_div"></div>
          </div>
        </template>
        <template v-if="website_id == '32' && pc ==false">
          <div class="login_icon loicon" @click="loginMenuShow = !loginMenuShow">

          </div>
        </template>
        <template v-if="website_id == '4' && pc ==false">
          <div class="login_iconfour loicon" @click="loginMenuShow = !loginMenuShow">
          </div>
        </template>

        <template v-if="website_id != '4' && pc ==false && website_id != '32'">
          <div class="login_icon_other loicon" @click="loginMenuShow = !loginMenuShow">
          </div>
        </template>

      </div>
    </div>
    <div class="tt-nav" :style="info.style" v-if="pc">
      <template v-for="item in navimglist">
        <img v-if="item.image" class="img-item navimglist-item" :src="item.image" alt="" :style="{width:item.style.width,height:item.style.height,left:item.style.marginLeft,top:item.style.marginTop}">
      </template>
        <template v-if="website_id == '40'">
          <div class="flex-row w1250 nav-content nav-content-diy" :style="{'--justifyContent':info.justifyContent}">
          <template v-for="(item,index) in navMenuList">
            <template v-if="item.name != '立即报名'">
              <div class="nav-text nav-text-diy" :class="navMenuId == item.id ? 'active' : ''"
                :style="{'--childTop':info.style.height,'--bgColor':info.hoverStyle.backgroundColor,'--color':info.hoverStyle.color}"
                @click="toList(item,index)" @mouseleave="hideMenu" @mouseenter="getMenu(item)">
                {{item.name}}
                <div class="fixed-menu fixed-menu-diy" v-show="navMenuId == item.id">
                  <template v-if="item.listData">
                    <div class="menu-box"
                      :style="{'backgroundColor':info.childStyle.backgroundColor,'--childBgColor':info.childHoverStyle.backgroundColor,'--childColor':info.childHoverStyle.color}">
                      <div class="bt-project-item" v-for="(items,jindex) in item.listData">

                        <div class="bt-name" v-if="items.list.length" :style="info.childStyle" >{{items.name}}</div>
                        <div class="bt-name" v-else @click.stop="toRoute(items,jindex)" :style="info.childStyle" >{{items.name}}</div>
                        <div v-for="(itemc,indexc) in items.list" :style="info.childStyle" class="menu-item" @click="toRoute(itemc,indexc)">{{itemc.name}}</div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="applybtn" @click="toList(item,index)">
                {{item.name}}
              </div>
            </template>
          </template>

          </div>

        </template>
        <template v-else>
          <div class="flex-row w1250 nav-content" :style="{'--justifyContent':info.justifyContent}">
          <template v-for="(item,index) in navMenuList">
            <div class="nav-text" :class="navMenuId == item.id ? 'active' : ''"
              :style="{'--childTop':info.style.height,'--bgColor':info.hoverStyle.backgroundColor,'--color':info.hoverStyle.color}"
              @click="toList(item,index)" @mouseleave="hideMenu" @mouseenter="getMenu(item)">
              {{item.name}}
              <a style="display: none;" :href="item.href">{{item.name}}</a>
              <div class="fixed-menu" v-show="navMenuId == item.id">
                <div class="menu-box"
                  :style="{'--childBgColor':info.childHoverStyle.backgroundColor,'--childColor':info.childHoverStyle.color}">
                  <template v-for="(items,jindex) in item.children">
                    <div class="menu-item" :style="info.childStyle" @click="toRoute(items,jindex)">{{items.name}}</div>
                    <a style="display: none;" :href="items.href">{{items.name}}</a>
                  </template>
                </div>
              </div>
            </div>
          </template>
          </div>
        </template>



    </div>

    <el-drawer
      title=""
      :with-header="false"
      size="80%"
      :visible.sync="loginMenuShow"
      direction="rtl">
      <div class="drawer_main">
        <div>
          <div class="login_box" v-if="website_id == '32'">
            <img src="https://cdn.rockysports.cn/mountain-login-user-icon.png" alt="">
            <div v-if="islogin!='1'">
              <div @click="goLogin(1)">登录</div> / <div @click="goLoginRegister(1)">注册</div>
            </div>
            <div v-else @click="goPersonCenter">
              {{userName}}
            </div>
          </div>
          <div class="list_box">
            <template v-for="(item,index) in navMenuList">
              <div @click="toList(item,index)" :class="actTab == item.id?'listmenu actmenu':'listmenu'">{{item.name}}
                <template v-if="item.children.length">
                  <div class="childrenMenu">
                    <div class="menu-item" v-for="items in item.children" @click="toRoute(items)">{{items.name}}</div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>

        <div class="quit_login_div" @click="quitLogin" v-if="islogin=='1' && website_id == '32'">
          退出登录
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
  export default {
    name: 'top',
    props:{
     queryName: {
       type: String,
       default(){}
     }
    },
    data() {
      return {
        navMenuList: [],
        navMenuId: '',
        num: 0,
        info: {
          background: '',
          show_menu: 1,
          style: {
            backgroundColor: '',
            color: ''
          },
          childStyle: {
            backgroundColor: '',
            color: ''
          },
          hoverStyle: {
            backgroundColor: '',
            color: ''
          },
          childHoverStyle: {
            backgroundColor: '',
            color: ''
          }
        },
        navimglist:[],
        list: [],
        islogin:0,
        userName:'',
        pc:true,
        loginMenuShow:false,
        actTab:''
      }
    },
    watch: {
      '$route': {
        handler(e) {
          this.getNav()
        },
        immediate: true
      },
    },
    mounted() {
      this.checkPlatform()

    },
    methods: {
      MenuShowChange(){
        this.loginMenuShow = !this.loginMenuShow
      },
      checkPlatform() {
        if ((navigator.userAgent.match(
            /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
          this.pc = false
        } else {
          console.log('电脑访问')
          this.pc = true
        }
      },
      goLogin(type){
        this.$router.push({name:'mountain-login',query: {website_id: this.$route.query.website_id,type:1}})
        if(!this.pc){
          this.loginMenuShow = !this.loginMenuShow
        }
      },
      goLoginRegister(type){
         this.$router.push({name:'mountain-login-register',query: {website_id: this.$route.query.website_id,type:1}})
        if(!this.pc){
          this.loginMenuShow = !this.loginMenuShow
        }
      },
      goPersonCenter(){
        this.$router.push({name:'mountain-person-center',query: {website_id: this.$route.query.website_id}})
        if(!this.pc){
          this.loginMenuShow = !this.loginMenuShow
        }
      },
      quitLogin(){
        localStorage.setItem('islogin', 0)
        localStorage.setItem('userName', '')
        localStorage.setItem('api_token','')
        this.userName = ''
        this.islogin = 0
         this.$router.push({name:'mountain-login',query: {website_id: this.$route.query.website_id,type:1}})
      },
      getNav() {
        if (this.num === 20) return
        let website_id = localStorage.getItem('WEBSITE_ID')
        this.website_id = website_id
        if(localStorage.getItem('islogin')==null){
           localStorage.setItem('islogin',0)
        }
        this.islogin = localStorage.getItem('islogin')
        this.userName = localStorage.getItem('userName')
        if (!website_id) {
          setTimeout(() => {
            this.getNav()
            this.num += 1
          }, 10)
        } else {
          let params = {
            page_type: 'top'
          }
          this.$api.get('/api/H5/website/pc_temp', {
            params: params
          }).then(res => {
            this.info = res.data.data
            this.list = res.data.list
            this.navimglist = res.data.navimglist
          })
          this.$api.get('/api/H5/website/navall_list').then(res => {
            this.navMenuList = res.data
            this.navMenuList.forEach((item) => {
              if(item.children.length){
                item.children.forEach((items)=>{
                  this.setNewData(items)
                })
              }else{
                this.setNewData(item)
              }
              if (item.url == 'mountain-policy') {
                localStorage.setItem('policynav', JSON.stringify(item.children))
              }
            })
            if(website_id == '40'){
              let list = JSON.parse(JSON.stringify(this.navMenuList))
              let arr = []
              list.forEach((item,i)=>{
                if(item.children.length){
                  item.listData = []
                  let key = 0
                  item.children.forEach((items,index)=>{
                    if(items.is_label){
                      key = key + 1
                     item.listData.push({
                        name: items.name,
                        is_label: items.is_label,
                        url:items.url,
                        route_type:items.route_type,
                        list: []
                     })
                    }else{
                      item.listData[key-1].list.push(items)
                    }
                  })
                }
              })
              this.navMenuList = list
            }
          })
        }
      },
      setNewData(item){
        if(item.route_type == 1){
          item.href = `${window.location.origin}/web/pc_website_template/${item.url}?website_id=${this.$route.query.website_id}`
          if (item.type == 6 || item.type == 7) {
            item.href = `${item.href}&id=${item.game_id}&name=${item.name}`
          }else{
            item.href = `${item.href}&id=${item.id}&type=1&name=${item.name}`
          }
        }
        if (item.route_type == 2) {
          if (item.url == '/') {
             item.href = `${window.location.origin}/web/pc_website_template/index?website_id=${this.$route.query.website_id}`
          } else {
            if(item.type == 9){
              item.href = `${item.href}&id=${item.game_id}&name=${item.name}`
            }else{
              item.href = item.url
            }
          }
        }
      },
      toList(e) {
        this.actTab = e.id
        if (e.children.length) return
        if (e.route_type == 1) {
          if (e.type == 6 || e.type == 7) {
            this.$router.push({
              name: e.url,
              query: {
                website_id: this.$route.query.website_id,
                id: e.game_id,
                name: e.name
              }
            })
            if(!this.pc){
              this.loginMenuShow = !this.loginMenuShow
            }
            return
          }
          this.$router.push({
            name: e.url,
            query: {
              website_id: this.$route.query.website_id,
              id: e.id,
              type: 1,
              name: e.name
            }
          })
          if(!this.pc){
            this.loginMenuShow = !this.loginMenuShow
          }
        }
        if (e.route_type == 2) {
          if (e.url == '/') {
            this.$router.push({
              name: 'index',
              query: {
                website_id: this.$route.query.website_id
              }
            })
          } else {
            window.open(e.url)
          }
          if(!this.pc){
            this.loginMenuShow = !this.loginMenuShow
          }
        }
      },
      toRoute(e,index) {
        if (e.route_type == 1) {
          if (e.type == 6 || e.type == 7) {
            this.$router.push({
              name: e.url,
              query: {
                website_id: this.$route.query.website_id,
                id: e.game_id,
                name: e.name
              }
            })
            if(!this.pc){
              this.loginMenuShow = false
            }
            return
          }
          this.$router.push({
            name: e.url,
            query: {
              website_id: this.$route.query.website_id,
              id: e.id,
              type: 1,
              name: e.name
            }
          })
          if(!this.pc){
            this.loginMenuShow = false
          }
        }
        if (e.route_type == 2) {
          if (e.url == '/') {
            this.$router.push({
              name: 'index',
              query: {
                website_id: this.$route.query.website_id
              }
            })
          } else {
            if(e.type == 9){
              this.$router.push({
                name: 'league-game-list',
                query: {
                  website_id: this.$route.query.website_id,
                  id: e.id,
                  name: e.name
                }
              })
            }else{
              window.open(e.url)
            }

          }
          if(!this.pc){
            this.loginMenuShow = false
          }
        }



      },
      getMenu(item) {
        this.navMenuId = item.id
      },
      hideMenu() {
        this.navMenuId = ''
      }
    }
  }
</script>

<style lang="less">

  @media screen and (min-width: 1100px) {
    .top-content {
      width: 100%;
      min-width: 1250px;
      background-color: var(--theme-color, #ffffff);

      .tt-top {
        // min-height: 100px;
        min-width: 1250px;
        // align-items: center;
        // justify-content: space-between;
        position: relative;
        // overflow: hidden;  ////////////
        overflow: unset !important;

        .top-background {
          width: 100%;
          height: inherit;
          position: absolute;
          z-index: 0;

          &.relative {
            position: relative;
          }
        }

        .img-box {
          margin: 0 auto;
          display: flex;
          overflow: unset !important;
          // overflow: hidden;


        }

        .img-item {
          position: relative;
        }
      }

      .tt-nav {
        position: relative;
        display: flex;
        justify-content: center;
        height: 68px;
        line-height: 68px;
        font-size: 20px;
        color: #FFFFFF;
        background-color: #3c3992;

        .nav-content {
          padding: 0 20px;
          position: relative;
          justify-content: var(--justifyContent);
          z-index: 9;
        }
        .navimglist-item{
          position: absolute;
          z-index: 50;
        }
      }

      .nav-text {
        padding: 0 30px;
        cursor: pointer;
        position: relative;
        z-index: 9;

        &.active {
          position: relative;
          display: flex;
          justify-content: center;
          color: var(--color, #FFFFFF);
          background-color: var(--bgColor, #d20e69);
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .fixed-menu {
        position: absolute;
        top: var(--childTop, 68px);
        left: 0;

        .menu-box {
          display: flex;
          flex-direction: column;
          color: #ffffff;
          // background-color: #7B79BC;
        }

        .menu-item {
          padding: 0 20px;
          width: 100%;
          // min-width: 160px;
          height: 68px;
          display: flex;
          align-items: center;
          // line-height: 1.2;
          font-size: 20px;
          cursor: pointer;
          box-sizing: border-box;
          background-color: #7B79BC;

          &:hover {
            color: var(--childColor, #FFFFFF) !important;
            background-color: var(--childBgColor, #d20e69) !important;
          }
        }
      }
      .applybtn{
        height: 30px;
        border: 1px solid #FFF;
        padding: 10px;
        line-height: 30px;
        border-radius: 10px;
        margin-top: 8px;
        cursor: pointer;
      }
    }
  }
  .login_module_box {
    position: absolute;
    right: 0;
    top: 12px;
    display: flex;
    .login_l_z{
      position: relative;
      font-size: 14px;
      color: #fff;
      line-height: 34px;
      padding-right: 20px;
      margin-right: 20px;
      min-width: 30px;
    }
    .login_l_z::after{
      position: absolute;
      display: inline-block;
      content: '';
      right: 0;
      top: 14px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 7px solid #fff;
    }
    .login_l_z:hover{
      .login-menu{
        display: flex;
      }
    }
    .user_icon_div {
      width: 35px;
      height: 35px;
      background: url('https://cdn.rockysports.cn/mountain-login-user-icon.png');
    }

    .login-menu {
      position: absolute;
      left: -54px;
      top: 27px;
      padding-top: 20px;
      width:140px;
      display: none;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      color: #ffffff;
      z-index: 99;
      div{
        cursor: pointer;
        padding: 9px 10px;
        text-align: center;
      }
      div:hover{
        color: var(--childColor, #FFFFFF) !important;
        background-color: var(--childBgColor, #d20e69) !important;
      }
    }
  }
  @media screen and (max-width: 1100px) {

    .top-content {
      width: 100%;
      min-width: unset;
      background-color: var(--theme-color, #ffffff);

      .tt-top {
        // min-height: 100px;
        // min-width: 1250px;
        // align-items: center;

        position: relative;
        overflow: hidden;

        .top-background {
          width: 100%;
          height: inherit;
          position: absolute;
          z-index: 0;

          &.relative {
            position: relative;
          }
        }

        .img-box {
          margin: 0 auto;
          display: flex;
          overflow: hidden;
          justify-content: space-between;
          box-sizing: border-box;
          padding-right: 20px;
        }

        .img-item {
          position: relative;
          width:80% !important;
          height: unset !important;
        }
      }

      .tt-nav {
        display: flex;
        justify-content: center;
        height: 68px;
        line-height: 68px;
        font-size: 20px;
        color: #FFFFFF;
        background-color: #3c3992;

        .nav-content {
          display: flex;
          padding: 0 20px;
          position: relative;
          justify-content: var(--justifyContent);
          z-index: 9;
        }
      }

      .nav-text {
        padding: 0 30px;
        cursor: pointer;
        position: relative;
        z-index: 9;

        &.active {
          position: relative;
          display: flex;
          justify-content: center;
          color: var(--color, #FFFFFF);
          background-color: var(--bgColor, #d20e69);
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .fixed-menu {
        position: absolute;
        top: var(--childTop, 68px);
        left: 0;

        .menu-box {
          display: flex;
          flex-direction: column;
          color: #ffffff;
          // background-color: #7B79BC;
        }

        .menu-item {
          padding: 0 20px;
          width: 100%;
          // min-width: 160px;
          height: 68px;
          display: flex;
          align-items: center;
          // line-height: 1.2;
          font-size: 20px;
          cursor: pointer;
          box-sizing: border-box;
          background-color: #7B79BC;

          &:hover {
            color: var(--childColor, #FFFFFF) !important;
            background-color: var(--childBgColor, #d20e69) !important;
          }
        }
      }
    }
    .top-content.league-game-list{
      min-width: unset;
    }
    .top-content.index{
       width: var(--componentWidth);
       min-width: unset;
    }
    .loicon{
      background: url('https://cdn.rockysports.cn/mountain-login-icon.png') no-repeat;
      background-size: 100% 100%;
      z-index: 99;
    }
    .login_icon{
      margin-top: 10px;
      width: 60px;
      height: 50px;

    }
    .login_iconfour{
      position: fixed;
      right: 0;
      top:60px;
      width: 90px;
      height: 80px;
    }
    .login_icon_other{
      position: fixed;
      right: 0;
      top:60px;
      width: 120px;
      height: 120px;
      background: url('https://cdn.rockysports.cn/pctem_menu_icon.png') no-repeat;
      background-position: center;
    }
    .el-drawer__body{
      background: #000;
      font-size: 46px;
      .drawer_main{
        display: flex;
        padding: 160px 50px 88px;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
        .login_box{
          text-align: center;
          color: #fff;
          img{
            width: 130px;
            height: 130px;
          }
          >div{
            margin-top: 20px;
            display: flex;
            justify-content: center;
            div{
              width: 140px;
            }
          }
        }
        .list_box{
          margin-top: 100px;
          div{
            margin-bottom: 30px;

            color: #333;
            background: #fff;
          }
        }
        .listmenu.actmenu{
          .childrenMenu{
            max-height: 240px;
            height: auto;
            overflow: auto;
          }
        }
        .childrenMenu{
          height: 0;
          overflow: hidden;
          transition: all .3s;
          .menu-item{
            margin-bottom: 0;
            font-size: 36px;
            line-height: 80px;
          }
        }


        .list_box div,.quit_login_div{
          text-align: center;
          width: 100%;
          line-height: 100px;
          font-weight: bold;
          font-size: 46px;
        }
        .quit_login_div{
         color: #fff;
          background: #C51616;
        }
      }
    }

  }

  .nav-text-diy{
    position: unset !important;
    &::after{
      content: '';
      position: absolute;
      bottom:4px;
      width: 0;
      height: 2px;
      background: var(--color, #FFFFFF);;
    }
    &.active {
      background-color: unset;
      &::after{
        width: 100px;
        transition: width .25s ease-in-out;
      }
    }
  }
  .nav-content-diy{
    position: relative;
  }
  .fixed-menu-diy{
    position: absolute;
    left:280px !important;
    // background: #FFFFFF;
    width: 800px;
    .menu-box{
      padding-bottom: 20px;
      padding-top: 20px;
      flex-direction: row !important;
      justify-content: space-between;
      // height: unset !important;
      .bt-project-item{
        padding-left: 10px;
        border-right: 1px solid rgba(128,128,128,.5);
        flex: 1;
        line-height: 36px;
        .bt-name{
          display: flex;
          padding-left: 10px;
          color: #2F4F4F;
          font-size: 22px;
          font-weight: bold !important;
        }
        .menu-item{
          padding: 0;
          padding-left: 10px;
          background-color: unset;
          height: unset;
          font-size: 16px;
          color: #2F4F4F;
        }
      }
      .bt-project-item:last-child{
        border-right:none;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/top.vue